module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Mountain People")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#location-maps"
    }
  }, [_vm._v("Location Maps")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#part-1-mountain-people"
    }
  }, [_vm._v("Part 1: Mountain People")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#a-special-kind-of-witness"
    }
  }, [_vm._v("1. A Special Kind of Witness")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#part-2-witnesses"
    }
  }, [_vm._v("Part 2: Witnesses")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#section-1"
    }
  })]), _c('a', {
    attrs: {
      "href": "#/text/ch010#section-1"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#section-1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/ch011#past-present-and-future-intertwined"
    }
  }, [_vm._v("2. Past, Present and Future\n                Intertwined")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#josep-and-maría-and-family",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Josep and María and Family")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#itchy-feet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Itchy Feet")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#a-rising-star",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. A Rising Star?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#your-place-or-mine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Your Place or Mine?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#a-landing-stage-at-the-end-of-the-rapids",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. A Landing Stage at the\n                End of the Rapids")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#magnetic-mountains",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Magnetic Mountains")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#lost-in-space",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Lost in Space")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#settled",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Settled")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#foreigners",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Foreigners?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#reintroduction",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Reintroduction")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#part-3-fate-hope-and-refusal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3: Fate, Hope and Refusal")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#background",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Background")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#fate",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Fate")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#fate-mobility-and-change",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fate, mobility and change")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#fate-depopulation-and-vanishing-ways-of-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fate,\n                        depopulation and vanishing ways of life")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#fate-exodus-of-the-young-and-who-wants-to-live-here-anyway",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fate, exodus\n                        of the young and who wants to live here anyway?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#fate-and-incomers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fate and incomers")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#fate-and-disunity-among-incomers-and-natives",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fate and\n                        disunity among incomers and ‘natives’")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#fate-and-local-impacts-of-wider-processes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fate and local\n                        impacts of wider processes")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#fatalism",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fatalism?")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#hope",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Hope")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#hope-through-accommodating-the-local-within-a-wider-sense-of-place",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hope\n                        through accommodating the local within a wider sense of place")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#hope-through-incomers-who-buy-into-the-local",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hope through\n                        incomers who buy into the local")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#in-ariège",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Ariège")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#in-the-cardós-valley",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Cardós Valley")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#hope-through-openness-and-respect-for-others",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hope through\n                        openness and respect for others")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#hope-through-creative-bricolage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hope through creative\n                        "), _c('em', [_vm._v("bricolage")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#active-hope-through-working-to-fulfil-visions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Active hope\n                        through working to fulfil visions")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#conclusion-hope-fate-and-refusal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 .Conclusion: Hope, Fate and\n                Refusal")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#postscript",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postscript")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#more-from-the-authors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More from the Authors")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#endnote",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnote")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-917484e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0